
import {errorHttpMessage} from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'
import { downloadFile } from "@/utils/filesUtil"
import {makeRestoreAction} from '@/utils/catalogRestoreAction'

export const save = async ({commit}, vaccinationRecord) => {
    try{
        const { data:result } = await configurationClient.post('/catalog/vaccination-records/create', vaccinationRecord)        
        const { message, error } = result.result    
        return {message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const findById = async ({commit}, vaccinationRecordId) => {
    try{        
        const { data:result } = await configurationClient.get(`/catalog/vaccination-records/show/${vaccinationRecordId}`)        
        const { data, message, error } = result.result    
        return {data, message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const edit = async ({commit}, vaccinationRecord) => {
    try{
        const { data:result } = await configurationClient.post(`/catalog/vaccination-records/${vaccinationRecord.id}`, vaccinationRecord)        
        const { message, error } = result.result    
        return { message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const deleteById = async ({commit}, vaccinationRecordId) => {
    try{        
        const { data:result } = await configurationClient.delete(`/catalog/vaccination-records/destroy/${vaccinationRecordId}`)        
        const { message, error } = result.result    
        return {message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const downloadExcelReport = async ({commit}, fileName) => {
    try{        
        const response = await configurationClient.get(`/catalog/vaccination-records/download`,{
            responseType: 'blob'
        })                
        downloadFile(response.data, fileName)
    } catch(ex) {                     
        console.log('error', ex)
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const restoreById = makeRestoreAction(configurationClient, '/catalog/vaccination-records')
